module.exports = __webpack_public_path__ + "img/cover0.3354d7ac.png";